<span [ngClass]="{ hide: hide, rotate: !isDesc }" class="material-icons sort-arrow">arrow_downward</span>
